import { render, staticRenderFns } from "./GeneralShortenedDisplay.vue?vue&type=template&id=6213f8bf&"
import script from "./GeneralShortenedDisplay.vue?vue&type=script&lang=js&"
export * from "./GeneralShortenedDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports